module.exports = __webpack_public_path__ + "img/m-nex25-menu-desktop.2f4bd169.png";